import { Component, Input, OnChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { primerStatusNames, sampleStatusNames } from '@shared/constants';
import { PrimerStatusEnum, StatusPillColorsEnum } from '@shared/enums';
import { SampleStatusEnum } from '@shared/enums/sample-status.enum';
import { TooltipModule } from 'primeng/tooltip';
import { StatusPillComponent } from '../../general/status-pill/status-pill.component';

@Component({
    selector: 'app-inventory-status',
    standalone: true,
    imports: [TranslateModule, TooltipModule, StatusPillComponent],
    templateUrl: './inventory-status.component.html',
    styleUrls: [],
})
export class InventoryStatusComponent implements OnChanges {
    @Input({ required: true }) status!: PrimerStatusEnum | SampleStatusEnum;
    @Input({ required: true }) statusType!: 'primer' | 'sample';
    @Input() size: 'large' | 'small' = 'small';

    readonly inventoryStatusColor = StatusPillColorsEnum;
    statusColor: StatusPillColorsEnum = StatusPillColorsEnum.RED;

    statusTooltip: string | null = null; // todo when we'll have the copy text
    statusName: string | null = null;

    ngOnChanges(): void {
        this.mapStatus();
    }

    mapStatus() {
        if (this.statusType === 'primer') {
            this.statusName = primerStatusNames[this.status as PrimerStatusEnum];

            switch (this.status) {
                case PrimerStatusEnum.AVAILABLE:
                    this.statusColor = StatusPillColorsEnum.GREEN;
                    break;
                case PrimerStatusEnum.OUT_OF_STOCK:
                    this.statusColor = StatusPillColorsEnum.RED;
                    break;
                case PrimerStatusEnum.PENDING:
                    this.statusColor = StatusPillColorsEnum.YELLOW;
                    break;
            }
        } else if (this.statusType === 'sample') {
            this.statusName = sampleStatusNames[this.status as SampleStatusEnum];

            switch (this.status) {
                case SampleStatusEnum.AVAILABLE:
                    this.statusColor = StatusPillColorsEnum.GREEN;
                    break;
                case SampleStatusEnum.EXPIRED:
                    this.statusColor = StatusPillColorsEnum.RED;
                    break;
                case SampleStatusEnum.NOT_RECEIVED:
                    this.statusColor = StatusPillColorsEnum.YELLOW;
                    break;
                case SampleStatusEnum.DISPOSED:
                    this.statusColor = StatusPillColorsEnum.RED;
                    break;
            }
        }
    }
}
